/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if(boostSDAppConfig?.filterSettings) {  boostSDAppConfig.filterSettings.filterLayout = 'horizontal';}